import axios from "axios";
const uribase = "https://www.lefisc.com.br/api/monitoramentoNCM/cliente";
const sandbase = 'https://www.lefisc.com.br/sandbox/cliente';
const buscaMonitoradas = "buscaMonitoradas";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";
//www.lefisc.com.br/sandbox/cliente/ContadorDeNCMsMonitorada/9502/64ad62a25fe48a9e8bcd84df737dd40b

export default {
  getMonitoradas(nPage, qPage, cliente) {
    return axios
      .get(`${uribase}/${buscaMonitoradas}/${nPage}/${qPage}/${cliente}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => console.error(err));
  }
};
